import {useEffect, useRef, useState} from "react";
import {instance} from "../../networking/axios";
import {Map} from "../../map/BaseMap";
import axios, {AxiosResponse, CancelTokenSource} from "axios";
import {Zones} from "./Zones";
import {AreaStyle} from "./Zones";
import {Area} from "./Zones";
import './ZonesView.css'
import ZoneLegendCarView from "./ZoneLegendCarView";
import ZonesAbilitiesView, {IZoneAbility} from "./abilities/ZonesAbilitiesView";
import EnterAddressView, {ISuggestResult, ISuggestResults} from "./EnterAddressView";
import fingerIcon from '../../imgs/finger_icon.png'
import {geocodeAddress} from "./Geocoding";
import {showZone} from "./MapHelpers";
import {ICity, IConstants} from "../model/B2CInfo";

const polygonClipping = require('polygon-clipping')

export interface IZonesViewState {
    zones?: Zones,
    selectedZone?: string,
}

interface IZonesViewProps {
    constants: IConstants
    city: ICity
}

export default function ZonesView(props: IZonesViewProps) {
    const [state, setState] = useState<IZonesViewState>({
        zones: undefined,
        selectedZone: undefined,
    })

    const [coordinate, setCoordinate] = useState<Array<number> | undefined>(undefined)

    const [addressText, setAddressText] = useState("")
    const [suggest, setSuggest] = useState<ISuggestResult | undefined>(undefined)
    const [abilities, setAbilities] = useState<Zones | undefined>(undefined);

    // @ts-ignore
    const [map, setMap] = useState<ymaps.Map>()

    const geocodeTextTokenSource = axios.CancelToken.source();
    const geocodePointTokenSource = axios.CancelToken.source();

    useEffect(() => {
        if (suggest === undefined) {
            return;
        }
        geocodeAddress(
            suggest.title.text,
            (a) => {
                map.setCenter(a.coords, 15, {duration: 300});
            },
            geocodeTextTokenSource
        );
        return () => geocodeTextTokenSource.cancel();
    }, [suggest])

    useEffect(() => {
        if (coordinate === undefined) {
            return;
        }

        geocodeAddress(
            `${coordinate[0]} ${coordinate[1]}`,
            (a) => {
                console.log(a.text)
                setAddressText(a.text)
            },
            geocodePointTokenSource
        );
        return () => geocodePointTokenSource.cancel();
    }, [coordinate]);

    useEffect(() => {
        if (state.zones == null || map == null) {
            return;
        }

        let selectedZone = state.zones.records.find((zone) => zone.id === state.selectedZone);
        if (selectedZone !== undefined) {
            map.geoObjects.removeAll();
            showZone(map, selectedZone)
        }
    }, [state.selectedZone, state.zones, map])

    useEffect(() => {
        const params = new URLSearchParams();
        params.append('use_styles', '1');

        instance
            .get('/api/fake/areas/operation/info', {
                params: params, headers: {
                    "Lat": props.city.coordinate[1],
                    "Lon": props.city.coordinate[0]
                }
            })
            .then((session: AxiosResponse<Zones>) => {
                setState({...state, zones: session.data, selectedZone: session.data.records[0].id})
            })
    }, [props.city]);

    useEffect(() => {
        if (coordinate === undefined) {
            return;
        }

        const params = new URLSearchParams();
        params.append('use_styles', '1');
        params.append('coordinate', `${coordinate[0]} ${coordinate[1]}`);

        instance
            .get('/api/fake/areas/operation/info', {params: params, headers: {
                    "Lat": props.city.coordinate[1],
                    "Lon": props.city.coordinate[0]
                }})
            .then((session: AxiosResponse<Zones>) => {
                setAbilities(session.data)
            })
    }, [coordinate, state.selectedZone]);

    useEffect(() => {
        if (map != null) {
            map.setCenter(props.city.coordinate, 10, {duration: 300});
        }
    }, [props.city])

    let cars = state.zones?.records.map((record) => {
        return <ZoneLegendCarView
            mobile={false}
            title={record.title}
            icon={record.icon}
            id={record.id}
            selected={state.selectedZone === record.id}
            constants={props.constants}
            onClick={() => setState({...state, selectedZone: record.id})}
        />
    })

    let ability = abilities?.records.find((zone) => zone.id === state.selectedZone);

    return <div className="Zones_view">
        <div className="Zones_view_legend">
            <div className="Zones_view_legend_cars_container">
                <div className="Zones_view_legend_title">На чём поедем</div>
                <div className="Zones_view_legend_cars">
                    {cars}
                </div>
            </div>
        </div>
        {state.zones !== undefined && <div className="Zones_view_map_container">
            <div className="Zones_view_map_container_item">
                <Map center={props.city.coordinate} callback={
                    // @ts-ignore
                    (map: ymaps.Map) => {
                        setMap(map);
                        setCoordinate(map.getCenter())
                        map.events.add('actionend', () => {
                            console.log('action end');
                            setCoordinate(map.getCenter());
                        })
                        map.events.add('actionbegin', () => {
                            console.log('action begin');
                            setAbilities(undefined)
                        })
                    }
                }
                />
            </div>

            <div className="Zones_view_map_container_item" style={{pointerEvents: "none"}}>
                <img src={fingerIcon} style={{zIndex: 7, width: "28px", height: "28px"}}/>
            </div>

            <div className="Zones_view_legend_abilities_container">
                <ZonesAbilitiesView mobile={false} record={ability}/>
            </div>

            <EnterAddressView text={addressText} onSelect={(a) => setSuggest(a)}/>
        </div>
        }

    </div>;
}